import { render, staticRenderFns } from "./SectionBreakElement.vue?vue&type=template&id=7e5dcdea&"
import script from "./SectionBreakElement.vue?vue&type=script&lang=js&"
export * from "./SectionBreakElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports